import api from "./api";

class AuthService {
  static async login(username, password) {
    try {
      const response = await api.post("/auth/login", {
        username,
        password,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static logout() {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
  }

  static isAuthenticated() {
    return !!localStorage.getItem("user");
  }
}

export default AuthService;